import { Badge, Button, IconButton, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { useGlobalContext } from "context/GlobalContext";
import { usePermissions } from "context/PermissionsContext";
import apiClient from "lib/api-client";
import React, { useEffect, useMemo, useState } from "react";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import { getIcon } from "utils/iconsConfig";
import ImageModal from "./ImageModal";
import SmallImage from "./SmallImage";
import StockInfoCard from "./StockInfoModal/StockInfoModal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Tooltip from "./Tooltip";
import ViewDetails from "./ViewDetails/ViewDetails";
import CreateProjectDetailsModal from "./CreateModal/CreateProjectDetailsModal";
import { useDispatch, useSelector } from "react-redux";

import { getProductIcon } from "../../assets/productIcon/Products";
import CreateStockOrderModal from "./CreateModal/CreateStockOrderModal";
import ReOrderSettingsModal from "./CreateModal/ReOrderSettinsModal";
import QuickCustomerOrder from "./CreateModal/QuickCustomerOrder";
import CreateModificationModal from "./CreateModal/CreateModificationModal";
import { ReactComponent as TrashIcon } from "assets/icons/DeleteIcon.svg";
import { ReactComponent as WhiteBagIcon } from "assets/sale_icon/sale.svg";
import RemoveModal from "./RemoveModal/RemoveModal";
import { removeFromMeltingCart } from "store/cartSlice";
import { useQueryClient } from "@tanstack/react-query";
import TrendTray from "./SetSalesModal/TrendTray";

const StockCard = ({ data, variant = "default", isBtn, addtoCart, btnTilte, selectedCartProducts, removeCart, presentInCatalog, allData, disableClick = false }) => {
  //console.log(" Button Title >>>>>>", btnTilte);
  // console.log("Data >>", data);

  const [details, setDetails] = useState([]);
  const isWhiteStockCard = variant === "black";
  const dispatch = useDispatch();
  const cartData = useSelector((state) => state.cart.cartData);
  const [qty, setQty] = useState(0);

  const resolveIcon = (type) => {
    if (!type) return null;
    const icon = getProductIcon(type, variant);
    if (icon) return icon;
    const fallbackIcon = getIcon(type);
    if (fallbackIcon) return fallbackIcon;
    return getProductIcon(type, "default");
  };
  const ConsistentIcon = ({ type, color }) => {
    const iconElement = getIcon(type, color);
    return React.cloneElement(iconElement, {
      style: { width: "21px", height: "21px", maxWidth: "21px", maxHeight: "21px" },
    });
  };
  const [imageModal, setImageModal] = useState({ isOpen: false, imgUrl: null, designNo: null });
  const [currentIndex, setCurrentIndex] = useState(null);
  const isFirstItem = currentIndex === 0;
  const isLastItem = currentIndex === allData?.length - 1 || allData?.length === 0;
  const [createModal, setCreateModal] = useState(false);
  const [createData, setCreateData] = useState(null);
  const [createProjectBtn, setCreateProjectBtn] = useState(null);
  const [hovered, setHovered] = useState(false);
  const [setModal, setSetModal] = useState(false);
  const { infoModalOpen, setInfoModalOpen, displaySetIcon, addToCart, removeFromCart } = useGlobalContext();
  const [stockInfo, setStockInfo] = useState(null);
  const [stockOrderModal, setStockOrderModal] = useState(false);
  const [reOrderModal, setReOrderModal] = useState(false);
  const [customerOrderModal, setCustomerOrderModal] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [createModificationModal, setCreateModificationModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [trendOpen, setTrendOpen] = useState(false);
  const permission = usePermissions();
  const queryClient = useQueryClient();
  const [isHidden, setIsHidden] = useState(!!data?.isHidden || false);
  // const hasAccessToSeeWatermark = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Other Settings", permission), "Watermark"), "view");
  const hasAccessToSeeWatermark = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Watermark"), "view") && !permission?.isAdmin;
  const hasStockTrayAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Miscellaneous Stock"), "stock_tray_info");
  const hasPriceDetailsAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Miscellaneous Stock"), "price_details");
  const hasAccessToSeeBestSeller = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Best Seller Border"), "view");

  const navigate = useNavigate();
  const location = useLocation();
  const isCreateOrder = location?.state?.newName === "Create Order";

  const isClientFlow = location?.pathname?.includes("client-flow");
  const isMeltingFlow = location?.pathname?.includes("melting-requests");

  const showDeleteIcon = useMemo(() => {
    return location?.state?.openCart && location?.state?.isMeltingFlow;
  }, [location]);

  // const handleCardClick = async (jewelCode) => {
  //   const lastName = location.state?.name?.[location.state.name.length - 1];
  //   const currentName = `${jewelCode} details`;
  //   if (lastName === currentName) {
  //     return;
  //   }
  //   setStockInfo(null);
  //   // setInfoModalOpen(false);
  //   try {
  //     setInfoModalOpen(true);
  //     const response = await apiClient.post("/api/v1/stocks/getSpecificStockDetails", { jewelCode });
  //     setStockInfo(response.data);
  //     // if (location.state.name?.[0]?.split(" - ")[0]?.includes("SET") && location.state.name.length <= 2) {
  //     const newName = `${jewelCode} details`;
  //     const newNameArray = [...location.state.name, currentName];
  //     navigate(`${location.pathname}/${data?.jewelId}`, {
  //       state: {
  //         ...location.state,
  //         name: newNameArray,
  //       },
  //     });
  //     // }
  //   } catch (error) {
  //     console.error("Error fetching stock info:", error);
  //   }
  // };

  const handleCardClick = async (jewelCode, data) => {
    if (isClientFlow || isMeltingFlow || disableClick) {
      return false;
    }

    if (!hasPriceDetailsAccess) {
      return false;
    }

    const currentName = `${jewelCode} details`;

    // If already on the correct jewel detail, skip
    const lastName = location.state?.name?.[location.state.name.length - 1];
    if (lastName === currentName) return;
    setStockInfo(null);
    setInfoModalOpen(true);

    try {
      const response = await apiClient.post("/api/v1/stocks/getSpecificStockDetails", { jewelCode });
      setStockInfo(response.data);
      const { jewelId } = data;
      const categoryName = data?.categoryName || data?.category;
      const formattedCategory = categoryName?.toLowerCase() || "stock";
      const pathname = location?.pathname;

      // For first level state ( ["Stock"])
      if (pathname.startsWith("/aiStock")) {
        const newNameArray = [currentName];
        const pathParts = pathname.split("/").filter(Boolean);
        const aiStockBase = `/${pathParts.slice(0, 3).join("/")}`;
        const directPath = `${aiStockBase}/${jewelId}`;

        navigate(directPath, {
          state: {
            name: newNameArray,
          },
        });
      } else if (location?.state?.name?.length === 1) {
        const newNameArray = [...location.state.name.slice(1), `${categoryName} Stock`, "All", currentName];
        const fullPath = `${pathname}/${formattedCategory}/all/${jewelId}`;

        navigate(fullPath, {
          state: {
            ...location.state,
            name: newNameArray,
          },
        });
      } else {
        const newNameArray = [...location.state.name, currentName];
        const newPath = `${pathname}/${jewelId}`;

        navigate(newPath, {
          state: {
            ...location.state,
            name: newNameArray,
          },
        });
      }
    } catch (error) {
      console.error("Error fetching stock info:", error);
    }
  };
  const handleCloseCreateModificationModal = () => {
    setCreateModificationModal(false);
    // setCreateProjectBtn(null);
  };
  const handleJwelecodeClick = async (jewelCode) => {
    try {
      if (isClientFlow) {
        return false;
      }

      if (!hasStockTrayAccess) {
        return false;
      }

      setInfoModalOpen(true);
      const response = await apiClient.post("/api/v1/stocks/getSpecificStockDetails", { jewelCode });
      setStockInfo(response.data);
    } catch (error) {
      console.error("Error fetching stock info:", error);
    }
  };

  const handleOpenImageModal = React.useCallback(
    (imgUrl, designNo) => {
      setImageModal({ isOpen: true, imgUrl, designNo });
      let newIndex = allData?.findIndex((item) => item?.styleNumber == designNo);
      setCurrentIndex(newIndex);
    },
    [allData]
  );

  const handleCloseImageModal = React.useCallback((e) => {
    e.stopPropagation();
    setImageModal({ isOpen: false, imgUrl: null, designNo: null });
    setCurrentIndex(currentIndex);
  }, []);

  const handleDeleteClick = (e) => {
    setDeleteModal(true);
  };

  // const hasViewLocationBBMAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Location Access"), "bbm");
  // const hasViewLocationHQAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Location Access"), "hq");
  // const hasViewLocationBBSAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Location Access"), "bbs");
  // const hasViewLocationIDLAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Location Access"), "idl");
  // const hasViewLocationBBMstockAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Location Access"), "bbm_customer_stock");
  // const hasViewLocationBBSstockAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Location Access"), "bbs_customer_stock");

  const getLocationIcon = (location) => {
    const locationMap = {
      "BBM Stock": { icon: "bbm", access: true },
      "BBS Stock": { icon: "bbs", access: true },
      "BBM Customer Stock": { icon: "bbmC", access: true },
      "BBS Customer Stock": { icon: "bbsC", access: true },
      "Headquarters Stock": { icon: "hq", access: true },
      "Idel Inventory": { icon: "idl", access: true },
    };

    const locationData = locationMap[location];

    if (!locationData || !locationData.access) {
      return null; // hide icon
    }

    return locationData.icon;
  };
  const locationIcon = getLocationIcon(data.location);

  const clientName = data?.status === "On Hand" ? data?.orderClientName : data?.status === "Memo" ? data?.memoClientName : "";

  const ModifyDiaQlty = (data?.diaQlty ?? "-").replace(/(.+)(..)$/, "$1-$2");
  const goldColor = data?.goldColor?.[0]?.toUpperCase() ?? "";
  const showDetails = React.useMemo(
    () => [
      {
        left: [
          { label: data?.jewelCode, Icon: resolveIcon("ring", variant), access: true, click: () => handleJwelecodeClick(data?.jewelCode) },
          { label: data?.styleNumber, Icon: resolveIcon(data?.designClass?.toLowerCase(), variant), access: true },
          {
            label: `${ModifyDiaQlty ?? 0} / ${data?.diaWt} Ct / ${data?.diaPcs} Pcs`,
            Icon: resolveIcon("diamond", variant),
            tooltipTitle: "Diamond Quality / Diamond Weight / Diamond Pieces",
            access: true,
          },
          {
            label: `${data?.goldQlty ?? 0}${goldColor} / ${data?.netWt} g / ${data?.grossWt} g `,
            Icon: resolveIcon("goldbar", variant),
            tooltipTitle: "Gold Purity / Gold Net Weight / Gold Gross Weight",
            access: true,
          },
          { label: `${data?.csWt} Ct / ${data?.csPcs} Pcs`, Icon: resolveIcon("gemstone", variant), tooltipTitle: "ColorStone Weight / ColorStone Pieces", access: true },
          { label: `${data?.otherWt} g / ${data?.otherPcs} Pcs`, Icon: resolveIcon("otherMaterial", variant), tooltipTitle: "OtherMaterial Weight / OtherMaterial Pieces", access: true },
          {
            label: `${data?.itemSize ?? 0} ${clientName ? "/" : ""} ${clientName?.slice(0, 19)?.trim() || ""}${clientName?.length > 20 ? "..." : ""}`,
            Icon: resolveIcon("scale", variant),
            tooltipTitle: clientName ? "Size / Client Name" : "Size",
            access: true,
          },
        ],
      },
      {
        middle: [
          {
            label: showDeleteIcon || isWhiteStockCard ? "Delete" : null,
            Icon: <TrashIcon style={{ width: "18px", height: "18px", maxWidth: "18px", maxHeight: "18px" }} />,
            // Icon: resolveIcon("DeleteIcon"),
            tooltipTitle: "Delete",
            access: showDeleteIcon || isWhiteStockCard,
            // badge: data?.styleOrderCount,
            click: handleDeleteClick,
          },
          {
            label: `${data?.memoClientName ? "Memo" : "Location"}`,
            Icon: data?.memoClientName ? resolveIcon("Memo", variant) : resolveIcon(getLocationIcon(data.location), variant),
            tooltipTitle: `${data?.memoClientName ? "Memo" : "Location"}`,
            access: true,
          },
          { label: data?.setDetails && data?.setDetails.length > 0 ? "setDetails" : null, Icon: resolveIcon("set", variant), click: () => setSetModal(true), tooltipTitle: "Sets", access: true },
          data?.status === "sold"
            ? {
                label: "sold",
                Icon: resolveIcon("sold", "red"),
                tooltipTitle: "Sold",
                access: true,
              }
            : null,
          {
            label: data?.memoClientName?.length > 25 || data?.orderClientName?.length > 5 ? "EyeIcon" : null,
            Icon: resolveIcon("eye", variant),
            tooltipTitle: data?.memoClientName || data?.orderClientName,
            access: true,
          },
          {
            label: data?.reorderData ? "Reorder" : null,
            Icon: resolveIcon("reorderIcon"),
            tooltipTitle: "Reorder",
            access: true,
            // badge: data?.styleOrderCount,
            // click: handleBinnysSelectOrder,
          },
          isMeltingFlow && data?.sales > 0
            ? {
                label: "sales",
                Icon: (
                  <Badge
                    badgeContent={data.sales}
                    sx={{
                      "& .MuiBadge-badge": {
                        backgroundColor: "#fff",
                        color: "#000",
                        fontSize: "9px",
                        fontWeight: 700,
                        width: "16px",
                        height: "16px",
                        minWidth: "unset",
                        padding: 0,
                        borderRadius: "50%",
                        transform: "translate(50%, -50%)",
                      },
                    }}
                  >
                    <WhiteBagIcon style={{ width: "18px", height: "18px" }} />
                  </Badge>
                ),
                tooltipTitle: `Total Sales: ${data.sales}`,
                access: true,
                click: (e) => { e.stopPropagation(); setTrendOpen(true); },
              }
            : null
        ],
      },
    ],
    [data, variant]
  );

  useEffect(() => {
    setDetails(showDetails);
  }, [showDetails]);

  const handleNextClick = () => {
    if (currentIndex < allData?.length - 1) {
      const newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      const nextItem = allData[newIndex];
      setImageModal((prev) => ({
        ...prev,
        isOpen: true,
        imgUrl: nextItem?.imageUrl ? nextItem?.imageUrl : null,
        designNo: nextItem?.styleNumber,
      }));
    }
  };

  const handlePrevClick = () => {
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      setCurrentIndex(newIndex);
      const prevItem = allData[newIndex];

      setImageModal((prev) => ({
        ...prev,
        isOpen: true,
        imgUrl: prevItem?.imageUrl ? prevItem?.imageUrl : null,
        designNo: prevItem?.styleNumber,
      }));
    }
  };

  //For Create Project Feature
  const handleRightClick = (event) => {
    event.preventDefault(); // stop default browser context menu
    if (isClientFlow || isMeltingFlow) {
      return false;
    }
    setCreateProjectBtn(
      createProjectBtn === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
          }
        : // close if already open
          null
    );
  };

  const handleCloseCreateProjectBtn = () => {
    setCreateProjectBtn(null);
  };

  const handleCloseCreateModal = () => {
    setCreateModal(false);
    setCreateProjectBtn(null);
  };

  const handleCreateDesign = (Design) => {
    //console.log("Paylod ------->", Design);
    handleCloseCreateModal();
  };

  useEffect(() => {
    if (allData?.length && data?.styleNumber) {
      const index = allData.findIndex((item) => item?.styleNumber === data.styleNumber);
      setCurrentIndex(index);
    }
  }, [allData]);

  useEffect(() => {
    if (!data?.styleNumber) return;
    const cartData = JSON.parse(sessionStorage.getItem("CartData") || "[]");

    const frequency = cartData.reduce((count, item) => (item.styleNumber === data.styleNumber ? count + 1 : count), 0);
    setQty(frequency);
  }, [data?.styleNumber, cartData]);

  const handleDelete = () => {
    dispatch(removeFromMeltingCart(data));
    setDeleteModal(false);
  };

  const deleteBtnInfo = [
    {
      btnName: "Remove",
      bgColor: "#E77B7B",
      click: () => handleDelete(),
    },
    {
      btnName: "Keep",
      bgColor: "#50C878",
      click: () => setDeleteModal(false),
    },
  ];

  return (
    <>
      <Box
        sx={{
          width: "525px",
          height: "232px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px",
          backgroundColor: isWhiteStockCard ? "#FFFFFF" : "#191818",
          color: isWhiteStockCard ? "#000000" : "#fff",
          borderRadius: "10px",
          border: data.bestSeller && hasAccessToSeeBestSeller ? "1px solid #C0C0C0" : "none",
          ...(data?.isHidden && {
            backgroundColor: "rgba(255, 255, 255, 0.15)",
          }),
        }}
        onContextMenu={handleRightClick}
      >
        <Box
          sx={{
            flex: 0.6,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            height: "100%",
          }}
        >
          {/* Left Content */}
          <Box className="right" onClick={() => handleCardClick(data?.jewelCode, data)}>
            {details[0]?.left?.map(
              (detail, index) =>
                detail.access && (
                  <Box
                    key={index}
                    className={`content-new content-new-${index}`}
                    display="flex"
                    alignItems="center"
                    onClick={
                      detail.click
                        ? (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            detail.click(e);
                          }
                        : undefined
                    }
                    sx={{ fontSize: "12px", cursor: "pointer" }}
                  >
                    {detail.click ? (
                      <IconButton disableFocusRipple disableRipple sx={{ p: 0 }} onClick={detail.click}>
                        {detail.Icon}
                      </IconButton>
                    ) : (
                      detail.Icon
                    )}
                    <Tooltip title={detail?.tooltipTitle} sx={{ marginTop: "2px" }}>
                      <Typography className={`content-typo content-typo-${index}`} ml={1} whiteSpace="nowrap">
                        {detail?.label}
                      </Typography>
                    </Tooltip>
                  </Box>
                )
            )}
          </Box>
          <Box
            className="middle"
            sx={{
              position: "relative",
            }}
          >
            {details[1]?.middle
              ?.filter((detail) => !(!displaySetIcon && detail?.label === "setDetails"))
              ?.map((detail, index) =>
                detail?.label ? (
                  <React.Fragment key={index}>
                    <Tooltip
                      title={detail?.tooltipTitle}
                      sx={{
                        marginTop: "4px",
                      }}
                    >
                      {detail?.access && detail?.Icon && (
                        <Box
                          className={detail?.label === "EyeIcon" || detail?.label === "sales" ? `` : `content-new content-new-${index}`}
                          onClick={detail?.label === "sales" ? detail?.click : undefined}
                          sx={{
                            fontSize: "12px",
                            cursor: detail?.label === "sales" ? "pointer" : "default",
                            ...(detail?.label === "EyeIcon" && {
                              position: "absolute",
                              bottom: 0,
                            }),
                            ...((detail?.label === "sales" || detail?.label === "makeType") && {
                            }),
                          }}
                        >
                          {detail.click && detail?.label !== "sales" ? (
                            <IconButton disableRipple disableFocusRipple sx={{ p: 0 }} onClick={detail?.click}>
                              <Badge
                                badgeContent={detail?.badge > 1 ? detail?.badge : null}
                                sx={{
                                  "& .MuiBadge-badge": {
                                    backgroundColor: "white",
                                    color: "white",
                                  },
                                }}
                              >
                                {detail?.Icon}
                              </Badge>
                            </IconButton>
                          ) : (
                            detail?.Icon
                          )}
                        </Box>
                      )}
                    </Tooltip>

                    {detail.label === "setDetails" && (
                      <ViewDetails
                        open={setModal}
                        setOpen={setSetModal}
                        list={data?.setDetails?.map((item) => ({
                          _id: item?._id,
                          name: `SET - ${item.setNumber}`,
                          imgUrl: data?.Orgimg ? data.Orgimg : Image,
                          styleNumber: data["styleNumber"],
                          numOfStyles: `${item.numOfStyles}`,
                        }))}
                        heading={`${data.styleNumber} Set`}
                        btnName="View Sets"
                      />
                    )}
                  </React.Fragment>
                ) : null
              )}
          </Box>
        </Box>

        <Box
          sx={{
            position: "relative",
            flex: 0.4,
            width: "212px",
            height: "212px",
            display: "flex",
            alignItems: isBtn ? "flex-start" : "center",
            justifyContent: "center",
          }}
        >
          <SmallImage data={data} isBtn={isBtn} handleOpenImageModal={handleOpenImageModal} hasAccessToSeeWatermark={hasAccessToSeeWatermark} />

          {/* {isBtn ? (
            <Button
              variant="contained"
              disabled={presentInCatalog || false}
              sx={{
                textTransform: "none",
                fontSize: "18px !important",
                position: "absolute",
                bottom: "0",
                backgroundColor: btnTilte === "Add" || btnTilte === "Select" ? "#FFFFFF" : "#50C878",
                color: btnTilte === "Add" || btnTilte === "Select" ? "#50C878" : "#ffffff !important",
                border: btnTilte === "Add" || btnTilte === "Select" ? "1px solid #50C878" : "none",
                "&:hover": {
                  backgroundColor: btnTilte === "Add" || btnTilte === "Select" ? "#FFFFFF" : "#50C878",
                },
                "&.Mui-disabled": {
                  backgroundColor: "#FFFFFF !important",
                  color: "#444444 !important",
                  border: "1px solid #444444 !important",
                },
                width: "110px !important",
                height: "40px !important",
                padding: "0px 20px !important",
                boxShadow: "0",
                fontFamily: "poppins",
              }}
              // onClick={btnTilte === "Add" ? handleAddToCartBtn : () => removeCart(selectedCartProducts)}
              onClick={btnTilte === "Add" || btnTilte === "Select" ? () => addtoCart(selectedCartProducts) : () => removeCart(selectedCartProducts)}
            >
              {btnTilte ? btnTilte : "Add"}
            </Button>
          ) : (
            ""
          )} */}

          {isBtn &&
            (isCreateOrder ? (
              qty === 0 ? (
                <Button
                  variant="contained"
                  disabled={presentInCatalog || false}
                  sx={{
                    textTransform: "none",
                    fontSize: "18px !important",
                    position: "absolute",
                    bottom: "0",
                    backgroundColor: btnTilte === "Add" ? "#FFFFFF" : "#50C878",
                    color: btnTilte === "Add" ? "#50C878" : "#ffffff !important",
                    border: btnTilte === "Add" ? "1px solid #50C878" : "none",
                    "&:hover": {
                      backgroundColor: btnTilte === "Add" ? "#FFFFFF" : "#50C878",
                    },
                    "&.Mui-disabled": {
                      backgroundColor: "#FFFFFF !important",
                      color: "#444444 !important",
                      border: "1px solid #444444 !important",
                    },
                    width: "110px !important",
                    height: "40px !important",
                    padding: "0px 20px !important",
                    boxShadow: "0",
                    fontFamily: "poppins",
                  }}
                  // onClick={btnTilte === "Add" ? () => addtoCart(selectedCartProducts) : () => removeCart(selectedCartProducts)}

                  onClick={() => {
                    addtoCart(selectedCartProducts);
                    setQty(1);
                  }}
                >
                  {"Add"}
                </Button>
              ) : (
                <Box
                  className="box"
                  variant="contained"
                  sx={{
                    height: "40px",
                    width: "90%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "10px",
                    // border: "1px solid red",
                    position: "absolute",
                    top: "80%",
                  }}
                >
                  <div
                    className="plus-icon"
                    onClick={() => {
                      if (qty > 1) {
                        setQty(qty - 1);
                        const cartItemToRemove = cartData.find((item) => item.styleNumber === data.styleNumber);
                        if (cartItemToRemove) {
                          removeCart(cartItemToRemove);
                        }
                      } else {
                        setQty(0);
                        removeCart(selectedCartProducts);
                      }
                    }}
                  >
                    -
                  </div>
                  <span className="quatity-text" style={{ background: qty > 0 ? "#50C878" : "#ffffff", color: qty > 0 ? "#ffffff" : "#50C878" }}>
                    {qty}
                  </span>
                  <div
                    className="plus-icon"
                    onClick={() => {
                      setQty(qty + 1);
                      addtoCart(selectedCartProducts);
                    }}
                  >
                    +
                  </div>
                </Box>
              )
            ) : (
              <Button
                variant="contained"
                disabled={presentInCatalog || false}
                sx={{
                  textTransform: "none",
                  fontSize: "18px !important",
                  position: "absolute",
                  bottom: "0",
                  backgroundColor: btnTilte === "Add" || btnTilte === "Select" ? "#FFFFFF" : "#50C878",
                  color: btnTilte === "Add" || btnTilte === "Select" ? "#50C878" : "#ffffff !important",
                  border: btnTilte === "Add" || btnTilte === "Select" ? "1px solid #50C878" : "none",
                  "&:hover": {
                    backgroundColor: btnTilte === "Add" || btnTilte === "Select" ? "#FFFFFF" : "#50C878",
                  },
                  "&.Mui-disabled": {
                    backgroundColor: "#FFFFFF !important",
                    color: "#444444 !important",
                    border: "1px solid #444444 !important",
                  },
                  width: "110px !important",
                  height: "40px !important",
                  padding: "0px 20px !important",
                  boxShadow: "0",
                  fontFamily: "poppins",
                }}
                // onClick={btnTilte === "Add" ? handleAddToCartBtn : () => removeCart(selectedCartProducts)}
                onClick={btnTilte === "Add" || btnTilte === "Select" ? () => addtoCart(selectedCartProducts) : () => removeCart(selectedCartProducts)}
              >
                {btnTilte ? btnTilte : "Add"}
              </Button>
            ))}
        </Box>

        {createProjectBtn !== null && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 999,
            }}
            onClick={() => {
              setCreateProjectBtn(null);
              setHovered(null);
            }} //to close btn click anywhere
          >
            <div
              className="createproject"
              style={{
                top: createProjectBtn.mouseY,
                left: createProjectBtn.mouseX,
              }}
              onClick={handleCloseCreateProjectBtn}
            >
              <div
                className="createproject-inner"
                onMouseEnter={() => setHovered("project")}
                onMouseLeave={() => setHovered(null)}
                onClick={() => {
                  let obj = {
                    styleNumber: data?.styleNumber,
                  };
                  setCreateData(obj);
                  setCreateModal(true);
                }}
              >
                {getIcon("CreateIcon", hovered === "project" ? "white" : "black")}
                Create Project
              </div>
              <div
                className="createproject-inner"
                onMouseEnter={() => setHovered("modification")}
                onMouseLeave={() => setHovered(null)}
                onClick={() => {
                  let obj = {
                    styleNumber: data?.styleNumber,
                    Orgimg: data?.Orgimg,
                    imageUrl: data?.imageUrl,
                    category: data?.category || data?.categoryName || "",
                  };
                  setCreateData(obj);
                  setCreateModificationModal(true);
                }}
              >
                {getIcon("CreateModify", hovered === "modification" ? "white" : "black")}
                Create Modification
              </div>

              <div
                className="createproject-inner"
                onMouseEnter={() => setHovered("customer")}
                onMouseLeave={() => setHovered(null)}
                onClick={() => {
                  setActionType("customer");
                  setStockOrderModal(true);
                  setCreateProjectBtn(null);
                }}
              >
                <ConsistentIcon type="Vision_Project_Icon" color={hovered === "customer" ? "white" : "black"} />
                {/* {getIcon("Vision_Project_Icon", hovered === "customer" ? "white" : "black")} */}
                Create Customer Quote
              </div>
              <div
                className="createproject-inner"
                onMouseEnter={() => setHovered("stock")}
                onMouseLeave={() => setHovered(null)}
                onClick={() => {
                  setActionType("stock");
                  setStockOrderModal(true);
                  setCreateProjectBtn(null);
                }}
              >
                <ConsistentIcon type="Vision_Project_Icon" color={hovered === "stock" ? "white" : "black"} />
                {/* {getIcon("Vision_Project_Icon", hovered === "stock" ? "white" : "black")} */}
                Create Stock Quote
              </div>

              <div
                className="createproject-inner"
                onMouseEnter={() => setHovered("reorder")}
                onMouseLeave={() => setHovered(null)}
                onClick={() => {
                  setActionType("reorder");
                  setStockOrderModal(true);
                  setReOrderModal(false);
                  setCreateProjectBtn(null);
                }}
              >
                <ConsistentIcon type="Vision_Project_Icon" color={hovered === "reorder" ? "white" : "black"} />
                {/* {getIcon("Vision_Project_Icon", hovered === "reorder" ? "white" : "black")} */}
                Set Re-Quote
              </div>
              <div
                className="createproject-inner"
                onMouseEnter={() => setHovered("Hide")}
                onMouseLeave={() => setHovered(null)}
                onClick={async () => {
                  try {
                    const newStatus = !isHidden;
                    const res = await apiClient.post("/api/v1/styles/hideStyle", {
                      styleNumber: data?.jewelCode,
                      hideStatus: newStatus,
                      cardType: "Stock",
                    });
                    setIsHidden(newStatus);
                    console.log("Style hidden successfully:", res.data);
                    queryClient.invalidateQueries(["styles"]);
                    queryClient.refetchQueries({ queryKey: ["styles"] });
                  } catch (error) {
                    console.log("Error hiding style:", error);
                  }
                }}
              >
                <ConsistentIcon type="Hide" color={hovered === "Hide" ? "white" : "black"} /> {data?.isHidden ? "Unhide Design" : "Hide Design"}{" "}
              </div>
            </div>
          </div>
        )}
      </Box>

      <ImageModal
        open={imageModal.isOpen}
        handleClose={handleCloseImageModal}
        data={imageModal}
        hasAccessToSeeWatermark={hasAccessToSeeWatermark}
        nextClick={() => handleNextClick()}
        prevClick={() => handlePrevClick()}
        hasNext={!isLastItem}
        hasPrev={!isFirstItem}
        selectedCartProducts={allData?.[currentIndex] ?? null}
      />
      <StockInfoCard open={infoModalOpen} setOpen={setInfoModalOpen} stockInfo={stockInfo} setStockInfo={setStockInfo} />
      <CreateProjectDetailsModal open={createModal} handleClose={handleCloseCreateModal} designData={createData} handleCreateDesign={handleCreateDesign} />
      <CreateStockOrderModal open={stockOrderModal} handleClose={() => setStockOrderModal(false)} designData={data} actionType={actionType} sourceType="stockcard" />
      <ReOrderSettingsModal open={reOrderModal} handleClose={() => setReOrderModal(false)} designData={data} actionType={actionType} />
      <QuickCustomerOrder open={customerOrderModal} handleClose={() => setCustomerOrderModal(false)} designData={data} actionType={actionType} />
      <CreateModificationModal open={createModificationModal} handleClose={handleCloseCreateModificationModal} designData={createData} />
      <RemoveModal open={deleteModal} setOpen={setDeleteModal} heading={`Do you want to remove ${data?.styleNumber} design?`} btnInfo={deleteBtnInfo} />
      <TrendTray open={trendOpen} handleClose={() => setTrendOpen(false)} no={data?.styleNumber} type="Design" />
    </>
  );
};

export default React.memo(StockCard);
